export default __webpack_public_path__ + "static/SRUS HF102 - Especification Del Producto y Datos Técnicos-ee6a21b1d2a4165cd39f6358c5940911.pdf";